import { render } from "./DownloadPage.vue?vue&type=template&id=7df5f922&scoped=true&ts=true"
import script from "./DownloadPage.vue?vue&type=script&lang=ts"
export * from "./DownloadPage.vue?vue&type=script&lang=ts"

import "./DownloadPage.vue?vue&type=style&index=0&id=7df5f922&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/DanhGia_FE_HV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df5f922"]])

export default __exports__